// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aCim","newExpiryDate":"styles_newExpiryDate__3n_ni","footer":"styles_footer__36Yiq"};